module.exports = __webpack_public_path__ + "static/media/earth_spirit.f3424378.png";